import { useEffect, useMemo, useSyncExternalStore } from 'react';

import { useAuth } from '../User';
import {
  DEFAULT_NOTIFICATIONS_POLL_INTERVAL,
  notificationsFeedStore,
} from './store';
import { getUnreadCount } from './utils';

export type UseNotificationsOptions = {
  pollInterval?: number;
};

export const useNotifications = ({
  pollInterval = DEFAULT_NOTIFICATIONS_POLL_INTERVAL,
}: UseNotificationsOptions = {}) => {
  const { organization_id } = useAuth();
  const snapshot = useSyncExternalStore(
    notificationsFeedStore.subscribe,
    notificationsFeedStore.getSnapshot
  );

  useEffect(() => {
    notificationsFeedStore.setOrganizationId(organization_id || null);
  }, [organization_id]);

  useEffect(() => {
    notificationsFeedStore.setPollInterval(pollInterval);
  }, [pollInterval]);

  const unreadCount = useMemo(
    () => getUnreadCount(snapshot.items, snapshot.lastReadAt),
    [snapshot.items, snapshot.lastReadAt]
  );

  return {
    items: snapshot.items,
    total: snapshot.total,
    loading: snapshot.status === 'loading',
    reloading: snapshot.status === 'reloading',
    unreadCount,
    refresh: notificationsFeedStore.refresh,
    markAllAsRead: notificationsFeedStore.markAllAsRead,
  };
};

export type UseNotificationsResult = ReturnType<typeof useNotifications>;
